export default "__VITE_ASSET__FwyXQElX__"